export const JOURNAL_DATES = '/api/v1/journals/for-parent/group-dates';
